<template>
    <div class="cursor-pointer">
        <ul class="overflow-auto" style="height: 240px">
            <li v-for="(item, index) in listData" :key="'ld' + index" class="p-12 d-flex">
                <el-avatar :size="32" src="../../../assets/image/message.png" />
                <div class="flex-column flex-x-between ml-8 font-12 color-65">
                    <span>{{ item.title }}</span>
                    <span class="color-25">
                        {{ item.opTime }}
                    </span>
                </div>
            </li>
        </ul>
        <div class="border-top d-flex">
            <div @click="clear()" class="flex-center col-12 py-12 border-right">
                清空通知
            </div>
            <!-- <div class="flex-center col-12 py-12" @click="$router.push({name: 'moreInfo',params:{
                status: this.status
            }})">查看更多</div> -->
            <div @click="routePush" class="flex-center col-12 py-12">
                查看更多
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Message',
    props: {
        notice: {
            type: null,
            default: () => {
                return [];
            }
        },
        doThing: {
            type: null,
            default: () => {
                return [];
            }
        },
        status: {
            type: String,
            default: () => {
                return '';
            }
        }
    },
    data() {
        return {
            listData: [
                // { name: '这是一条系统公告', time: '2019' },
                // { name: '这是一条系统公告', time: '2019' },
                // { name: '这是一条系统公告', time: '2019' },
                // { name: '这是一条系统公告', time: '2019' }
            ]
        };
    },
    created() {
        this.$nextTick(() => {
            this.status === 'first' ? (this.listData = this.notice) : this.doThing;
        });
    },
    methods: {
        clear() {
            if (this.status === 'first') {
                // 通知
                this.$http.get(this.$service.main.clearMes + '?type=message').then(res => {
                    if (res && !res.data) {
                        this.$emit('clear-first', false);
                        this.$message({
                            message: '清除成功',
                            type: 'success'
                        });
                    }
                });
            } else {
                // 代办
                this.$http.get(this.$service.main.clearMes + '?type=backlog').then(res => {
                    if (res && !res.data) {
                        this.$emit('clear-second', false);
                        this.$message({
                            message: '清除成功',
                            type: 'success'
                        });
                    }
                });
            }
        },
        routePush() {
            this.$emit('more', false);
            this.$router.push({
                name: 'moreInfo',
                params: {
                    status: this.status || 'first'
                }
            });
        }
    }
};
</script>
